export default {
  methods: {
    cleanData (value) {
      return value.replace(new RegExp('_', 'g'), ' ')
    }
  }
};